import React from "react"
import moment from "moment"

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"
import "./Transactions.css"

import Card from "../core/Card"
import {
  Icon,
  BackIcon,
  BriefcaseIcon,
  CarIcon,
  DotIcon,
  GearIcon
} from "../core/icons"
import {
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown
} from "antd"
import { connect } from "react-redux"
import {
  batchClassify,
  toggleTransaction,
  loadMore,
  getTransactions,
  updateRange,
  selectFilter,
  clearFilters,
  selectPlaceFilter,
  untoggleAllTransactions
} from "./actions"
import Summary from "./Summary"
import { withPreviousDate } from "./reducer"
import TransactionLine from "./TransactionLine"
import All from "./All"
import Update from "./Update"
import Create from "./Create"
import TitleBar from "./TitleBar"
import BankFetchingInfo from "./BankFetchingInfo"

const Transactions = () => (
  <div className="Transactions">
    <TitleBar />
    <Summary />
    <BankFetchingInfo />
    <All />
  </div>
)

export default () => (
  <Switch>
    <Route path={"/transactions/new/:transactionType"} component={Create} />
    <Route path={"/transactions/:transactionId"} component={Update} />
    <Route path={"/transactions"} component={Transactions} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/transactions/Transactions.js